// extracted by mini-css-extract-plugin
module.exports = {"depositDetails":"_da68288","info":"_fc9e3c8","infoTitle":"_0e1438f"};